import { Injectable } from '@angular/core';
declare var window;
@Injectable()
export class mapsService {
    url="";
      constructor(){
      }
      doSomethingGoogley(key) {
        this.url = 'https://maps.googleapis.com/maps/api/js?libraries=places&key=' + key + '&callback=__onGoogleLoaded';
          return new Promise((resolve) => {
            window['__onGoogleLoaded'] = (ev) => {
              resolve(window.gapi);
            };
            if (!window.google || !window.google.maps) {
              this.loadScript();
            }else{
              resolve(true)
            }
          });
      }
      loadScript() {
          const node = document.createElement('script');
          node.src = this.url;
          node.type = 'text/javascript';
          document.getElementsByTagName('head')[0].appendChild(node);
      }
}


// WEBPACK FOOTER //
// ./src/providers/maps/maps.service.ts